#import "../../../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql"

fragment ContactsForLeadFragment on Lead {
    id
    contacts(first: 100) {
        primaryEdge {
            node {
                ...ContactForCoreEntityFragment
            }
        }
        nonCompanyMappedContacts {
            node {
                ...ContactForCoreEntityFragment
            }
        }
    }
}
